import {
    useState,
} from 'react'
import SharedContextProvider from 'app/shared-components/SharedContext'
import FormWithControls from 'app/shared-components/FormWithControls'
import {
    FeesType,
} from 'app/enums/common.enums'
import useFieldsWithClassName from 'app/hooks/useFieldsWithClassName'
import {
    AdditionalFeesStatus,
} from 'app/enums/label.enums'
import useEnumValues from 'app/hooks/useEnumValues'
import {
    RequestConfig,
} from 'app/types/request.types'
import useContractBasisContext from 'app/Apps/Pricing/ContractBasis/hooks/useContractBasisContext'

import {
    AdditionalFeeValue,
} from '../AdditionalFee.types'

import useStyles from './AdditionalFeesForm.styles'
import additionalFeesFields from './AdditionalFeesForm.fields'

const defaultProps = {
    requestParams: undefined,
    customButtons: [],
    disabled: false,
}

export default function AdditionalFeesForm({
    disabled,
    value,
    onSuccess,
    onCancel,
    requestParams,
    customButtons,
}: Readonly<{
    disabled?: boolean,
    value: AdditionalFeeValue,
    onSuccess: (...a: any[]) => void,
    onCancel: (...a: any[]) => void,
    requestParams?: RequestConfig,
    customButtons?: JSX.Element[]
}>) {
    const {
        classes,
    } = useStyles()
    const getAllowedValues = useEnumValues()

    const [
        modifiedValue,
        setModifiedValue,
    ] = useState(value)

    const {
        currency: contractBasisCurrency,
    } = useContractBasisContext()

    const exists = Boolean(value?.id)

    const fields = useFieldsWithClassName(
        additionalFeesFields(
            {
                ccy: contractBasisCurrency,
                fxRate: modifiedValue.fxRate,
                fees: value.fees,
                exists,
                originalStatus: value.additionalFeesStatus,
                editingAllowed: value?.additionalFeesStatus
                    !== AdditionalFeesStatus.IN_PROGRESS,
                editingCommentAllowed: value.additionalFeesStatus
                    !== AdditionalFeesStatus.VALID,
                getAllowedValues,
            },
        ),
        classes,
    )

    return (
        <SharedContextProvider
            value={{
                feePricingName: FeesType.Additional,
            }}
        >
            <FormWithControls
                name="AdditionalFees"
                value={value}
                onSuccess={onSuccess}
                fields={fields}
                classNames={{
                    gridWrapper: classes.gridWrapper,
                }}
                disabled={disabled}
                requestParams={requestParams}
                exists={exists}
                onCancel={onCancel}
                customButtons={customButtons}
                setExternalValue={setModifiedValue}
            />
        </SharedContextProvider>
    )
}

AdditionalFeesForm.defaultProps = defaultProps
